import { Fragment, useEffect, useRef, useState, useContext } from "react"; import ErrorLabel from '../../components/error';
import Skeleton from 'react-loading-skeleton'
let lang = localStorage.getItem("i18nextLng");
const languageDir = "language-" + lang;
export function DropDownInput({
    styles,
    title,
    placeholder,
    disabled = false,
    className,
    classDropdownField,
    fieldTextClass,
    isSecondary,
    selectedValue = null,
    inputName,
    options = null,
    onSelect,
    defaultOption = null,
    currentOption = null,
    onfilter,
    isepart,
    isLoading = false,
    errorLabel,
    force = false
}) {
    const optionsRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState((defaultOption != null && defaultOption != undefined) ? defaultOption : { text: '', value: '' });


    // useEffect(() => {
    //     console.log(">>>>>>>>>>>>.:", selectedValue);
    //     if (defaultOption?.value)
    //         setSelectedOption(defaultOption);
    // }, [defaultOption]);


    useEffect(() => {

        function handleClickOutside(event) {
            if (optionsRef.current && !optionsRef.current.contains(event.target) && isOpen === true) {
                setIsOpen(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionsRef, isOpen]);
    function selectOption(option) {

        if (selectedOption.value !== option.value) {
            if (onSelect) {
                const val = option.value !== '0' ? option.value : '';
                onSelect(val);
            }
            setIsOpen(false);
            setSelectedOption(option);
            if (onfilter)
                if (defaultOption?.value !== option.value)
                    onfilter(option);
        } else {

            setIsOpen(false);
        }
    }

    useEffect(() => {
      
        if (selectedValue == null || selectedValue == undefined) {
      
            setSelectedOption((defaultOption != null && defaultOption != undefined) ? defaultOption : ((defaultOption != null && defaultOption != undefined) ? defaultOption : { text: '', value: '' }));
        } else {

            var vv = options.find(item => item.value === selectedValue) ?? null;
         
            setSelectedOption(vv ? vv : { text: '', value: '' });
        }

    }, [selectedValue]);

    return (

        <Fragment>

            {
                inputName ? (
                    <input type="hidden" value={selectOption.value} />
                ) : null
            }

            <div className={"dropdown " + languageDir + ' ' + className}>

                {
                    title &&
                    <div className={"dropdown-label " + (isSecondary && "secondary")}>{title}
                    </div>
                }

                <div ref={optionsRef} className={"dropdown-input"}>
                    <div className={"dropdown-field bg-theme-up  " + classDropdownField + " " + (errorLabel && 'border-danger') + " " + (isSecondary && "secondary")} style={styles ? styles : null} onClick={() => {
                        setIsOpen(!isOpen);
                    }}>
                        <div className={"dropdown-field-text " + fieldTextClass}>
                            {

                                selectedOption.text

                            }
                        </div>
                        <div className={"dropdown-field-arrow " + (isOpen && "invert")}>
                            <img src="/assets/icons/arrow.svg" alt="arrow" />
                        </div>

                    </div>
                    {

                        isLoading ?
                            <div className={"dropdown-options " + (isOpen || "hidden")}>
                                <ul>
                                    <li>
                                    <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"3rem"}
                                        containerClassName={"my-5"} className={"flex"} inline={true} />
                                    </li>
                                    <li>
                                    <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"3rem"}
                                        containerClassName={"my-5"} className={"flex"} inline={true} />
                                    </li>
                                    <li>
                                    <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"3rem"}
                                        containerClassName={"my-5"} className={"flex"} inline={true} />
                                    </li>

                                </ul>
                            </div>
                            :

                            !disabled && <div className={"dropdown-options " + (isOpen || "hidden")}>
                                <ul>
                                    {
                                        options.map((option, index) => {

                                            return (
                                                <li key={index+1}
                                                    className={((index % 2) == 0) ? " bg-secondary " : ""}

                                                    onClick={() => {
                                                        selectOption(option);
                                                    }}>
                                                    <span>{option.text}</span>
                                                </li>
                                            );

                                        }
                                        )
                                    }

                                </ul>




                            </div>
                    }


                </div>

            </div>

        </Fragment>
    );
}
